import { Trans } from '@/components'
export function StatsCards(props: {
  activeMembers: number
  inactiveMembers: number
  administratorNumbers: number
  totalTeamSeats: number
}) {
  const items = [
    {
      key: 'activeMembers',
      label: <Trans i18nKey="team.member.actiivatedMember">Activated Members</Trans>,
      value: props.activeMembers,
    },
    {
      key: 'inactiveMembers',
      label: <Trans i18nKey="team.member.inactiveMember">Inactivated Members</Trans>,
      value: props.inactiveMembers,
    },
    {
      key: 'administratorNumbers',
      label: <Trans i18nKey="team.member.administratorNumber">Administrator Numbers</Trans>,
      value: props.administratorNumbers,
    },
    {
      key: 'totalTeamSeats',
      label: <Trans i18nKey="team.member.totalTeamSeats">Total team seats</Trans>,
      value: props.totalTeamSeats,
    },
  ]
  return (
    <div className="grid grid-cols-4 text-secondary gap-x-4">
      {items.map((item) => (
        <div key={item.key} className="border border-neutral-100 p-6 rounded-2xl">
          <div className="t-x-sb text-secondary mb-2">{item.label}</div>
          <div className="h4 text-primary">{item.value}</div>
        </div>
      ))}
    </div>
  )
}
